import React, { Component } from 'react';
import ReactImageMagnify from 'react-image-magnify';

class ProductImage extends Component {



    render() {
        return (
            <div style={{ width: '100%', zIndex: '5' }}>
                
                <ReactImageMagnify {...{
                    smallImage: {
                        alt: 'Wristwatch by Ted Baker London',
                        isFluidWidth: true,
                        src: require('../../images/home/main2.jpg')
                    },
                    largeImage: {
                        src: require('../../images/home/main2.jpg'),
                        width: 1200,
                        height: 1800
                    },
                    isHintEnabled: true,
                    shouldHideHintAfterFirstActivation: false
                }} />
            </div>
        );
    }
}

export default ProductImage;
